export const NAME = 'legalBenefit'

export const GET_LEGAL_ROUTE = 'clientBenefitsLegalplanGet'
